import { api } from './api';

export interface GenSummaryResponse {
  summary: string;
}

export const aiApi = api.injectEndpoints({
  endpoints: (builder) => ({
    genSummary: builder.mutation<GenSummaryResponse, string>({
      query: (userId) => ({
        url: `/ai/summary/${userId}`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGenSummaryMutation } = aiApi;
